export default __webpack_public_path__ + "static/media/ridgebeam.b7604df4.webp";